import type { Person, Task } from "../../api/hub/types";
export const ownerLabel = (
  task: Pick<Task, "assigneeId" | "assigneeType">,
  people: Person[],
) => {
  const name =
    people.find((p) => p.id === task.assigneeId)?.name ??
    (task.assigneeId ? `目录外成员（${task.assigneeId}）` : "未指派");
  return task.assigneeType === "agent" ? `${name}的 AI` : name;
};
export const flagLabel = (flag: NonNullable<Task["issueFlags"]>[number]) => {
  const value =
    typeof flag === "string"
      ? flag
      : (flag.message ?? flag.reason ?? flag.kind ?? flag.code ?? "待核对");
  return (
    (
      {
        stuck: "卡住没动",
        stale: "卡住没动",
        stalled: "卡住没动",
        date_conflict: "日期矛盾",
        deadline_after_milestone: "晚于里程碑",
        suspected_duplicate: "疑似重复",
        missing_evidence: "缺完成证据",
        evidence_mismatch: "证据与状态不符",
        crowded: "到期扎堆",
      } as Record<string, string>
    )[value] ?? value
  );
};
export function TaskFlags({ task }: { task: Pick<Task, "issueFlags"> }) {
  return (
    <>
      {task.issueFlags?.map((f, i) => (
        <span className="work-flag" key={i}>
          {flagLabel(f)}
        </span>
      ))}
    </>
  );
}
export const safeReference = (value: string) =>
  /^(https?:\/\/|\/[^/])/.test(value) ? value : undefined;
export function EvidenceLinks({
  task,
}: {
  task: Pick<Task, "completionEvidence">;
}) {
  return task.completionEvidence?.length ? (
    <>
      {task.completionEvidence.map((e, i) =>
        safeReference(e.reference) ? (
          <a key={i} href={e.reference} target="_blank" rel="noreferrer">
            {e.type === "commit"
              ? "提交"
              : e.type === "document"
                ? "文档"
                : "链接"}{" "}
            {i + 1}
          </a>
        ) : (
          <span key={i}>{e.reference}</span>
        ),
      )}
    </>
  ) : (
    <span className="work-meta">暂无证据</span>
  );
}

export function sourceLabel(source: string | undefined, people: Person[]) {
  if (!source) return "未记录";
  if (source.startsWith("ai:"))
    return ownerLabel(
      { assigneeId: source.slice(3), assigneeType: "agent" },
      people,
    );
  return (
    (
      {
        human: "人",
        person: "人",
        builtin: "内置 AI",
        feishu: "飞书同步",
        feishu_sync: "飞书同步",
        legacy: "迁移记录",
      } as Record<string, string>
    )[source] ?? source
  );
}
